// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

// TODO: Order should just be of type ExtraProduct. the other fields are being injected by getOrder in Format.jsx and getExtraProductStructure in transformData.js

export const isOrderTypePostbooking = order => {
  return 'availableExtraProducts' in order;
};
//# sourceMappingURL=models.js.map